// TODO core token
// とりあえず名前つけてあとでコアトークンに置換できるようにしておく
const core = {
  primary: '#ff6b00',
  base: '#F9F9F9',
  sub: '#8A8A8D',
  white: '#FFFFFF',
  success: '#59A7D7',
  error: '#FF4B4B',
  border: '#CFCFCF',
  bgPrimary: '#F5F5F5',
};

export const themeColor = {
  brand: {
    primary: core.primary,
  },
  background: {
    base: core.base,
    primary: core.bgPrimary,
  },
  text: {
    sub: core.sub,
  },
  other: {
    white: core.white,
  },
  state: {
    success: core.success,
    error: core.error,
  },
  status: {
    caution: core.error,
  },
  border: {
    primary: core.border,
  },
};
